export enum ScreenControlIcons {
    OPERATION_STATUS_FINISHED = 'mdi-check-bold',
    OPERATION_STATUS_IN_PROGRESS = 'mdi-play-circle',
    OPERATION_STATUS_FINISHED_LATE = 'mdi-clock-alert',
    OPERATION_STATUS_STARTED_LATE = 'mdi-clock-fast',
    OPERATION_STATUS_NOT_STARTED = '',
    OPERATION_STATUS_CANCELLED = 'mdi-cancel',
    OPERATION_STATUS_EMERGENCY = 'mdi-exclamation-thick',
}

export enum ScreenControlColors {
    OPERATION_STATUS_FINISHED = '#1E7E34',
    OPERATION_STATUS_IN_PROGRESS = OPERATION_STATUS_FINISHED,
    OPERATION_STATUS_FINISHED_LATE = '#FF0000',
    OPERATION_STATUS_STARTED_LATE = '#ED7F10',
    OPERATION_STATUS_NOT_STARTED = '',
    OPERATION_STATUS_CANCELLED = '#666666',
    OPERATION_STATUS_EMERGENCY = '#FF0000',
}
